import React from "react"
import { MULTIPLAYER_USER_COLORS } from "../utils/constants"

type MultiplayerUserMarkerProps = {
  firstName: string
  lastName: string
  mouseX: number
  mouseY: number
  userIndex: number
}

export const MultiplayerUserMarker: React.FC<MultiplayerUserMarkerProps> = ({
  firstName,
  lastName,
  mouseX,
  mouseY,
  userIndex,
}) => {
  const color =
    MULTIPLAYER_USER_COLORS[userIndex % MULTIPLAYER_USER_COLORS.length]

  return (
    <div
      style={{
        position: "absolute",
        left: `${mouseX}px`,
        top: `${mouseY}px`,
        pointerEvents: "none",
        zIndex: 1000,
        transition: "left 0.2s ease, top 0.2s ease",
      }}
    >
      <svg
        width="12"
        height="17"
        viewBox="0 0 12 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 16.015V0L11.591 11.619H4.55L4.399 11.743L0 16.015Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 2.40723V13.5952L3.969 10.7292L4.129 10.5902H9.165L1 2.40723Z"
          fill={color}
        />
      </svg>
      <div
        style={{
          fontSize: "12px",
          color: color,
        }}
      >
        {firstName} {lastName}
      </div>
    </div>
  )
}
